<template>
  <div class="toast" v-show="isShow">
    <div class="toast-type" v-if="type">
      <div class="toast-box">
        <span :class="type"></span>
        <span class="message">{{ message }}</span>
      </div>
    </div>

    <div class="no-type" v-else>
      <div>
        <span >{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      type: "success",
      message: "加载中。。。",
      timeout: null,
    };
  },
  methods: {
    show(message, type, duration = 3000) {
      this.type = type;
      this.isShow = true;
      this.message = message;
      if (this.timeout != null) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.isShow = false;
        this.message = "";
      }, duration);
    },
  },
};
</script>

<style lang="less" scoped>
.toast {
  pointer-events: none;
  
  .toast-type {
    display: flex;
    justify-content: center;
    width: 272px;
    height: 260px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 8px 10px;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 16px;
    .toast-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      span:nth-child(1) {
        display: inline-block;
        margin: 0 auto 24px;
        width: 96px;
        height: 96px;

        &.success {
          background: url("https://xhdata.wan4.com/success-icon.png") no-repeat
            center center;
          background-size: 96px 96px;
        }

        &.fail {
          background: url("https://xhdata.wan4.com/fail-icon.png") no-repeat
            center center;
          background-size: 96px 96px;
        }
        &.warning {
          background: url("https://xhdata.wan4.com/wepapp-145.png") no-repeat
            center center;
          background-size: 96px 96px;
        }
      }

      .message {
        // width: auto;
        // height: auto;
        // line-height: 260px;
        color: #fff;
        font-size: 28px;
        text-align: center;
      }
    }
  }

  .no-type {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 28px 35px;
    display: flex;
    align-items: center;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 16px;
    line-height: 44px;
    // max-width: 380px;
    min-height: 104px;
    > div {
      // display: flex;
      font-size: 28px;
      color: #fff;
      // word-break: break-all;
      // max-width: 280px;
      // max-width: 700px;
    }
    .message {
    }
  }
}
</style>
